import { hasDraftContent, type ActiveDraft, type Note } from '../domain/note'
import { draftMatchesNote } from '../sync/activeNoteSync'

/** Already durable notes and untouched empty captures need no storage work.
 * Pending older commits must settle before declaring the current draft clean. */
export function persistNavigationDraft(
  snapshot: ActiveDraft,
  saved: Note | undefined,
  pendingCommit: boolean,
  operations: {
    save: (draft: ActiveDraft) => Promise<void>
    commit: (draft: ActiveDraft) => Promise<Note | null>
    discard: (draft: ActiveDraft) => Promise<Note | null>
  },
): Promise<Note | null> {
  if (!pendingCommit && saved && draftMatchesNote(snapshot, saved)) return Promise.resolve(saved)
  if (!hasDraftContent(snapshot)) {
    if (!saved && !pendingCommit) return Promise.resolve(null)
    return operations.discard(snapshot)
  }
  return operations.save(snapshot).then(() => operations.commit(snapshot))
}
